import { DisplayObject } from 'pixi.js';
import GameObject from '../../GameObject/GameObject';

export type Layout<T> = { [key in keyof T]: any };

export type GLayout<T extends Layout<T>> = {
    [k in keyof T]: T[k] extends DisplayObject ? GameObject<T[k]>
      : T[k] extends Layout<any> ? GLayout<T[k]>
        : T[k] extends Layout<any>[] ? GLayout<T[k]>[] :
          never;
};

export function getLayout<T extends Layout<T>>(layoutType: { new (): T }): GLayout<T> {
    return (new layoutType() as unknown) as GLayout<T>;
}
